/**
 * 404 页面组件
 *
 * 当用户访问不存在的路径时显示此页面。
 * 提供友好的提示信息和返回指引。
 */
export function NotFound(): React.JSX.Element {
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '3rem', margin: '0 0 1rem' }}>404</h1>
      <p style={{ color: '#666' }}>页面未找到</p>
      <p style={{ color: '#999', fontSize: '0.875rem' }}>
        请检查分享链接是否正确
      </p>
    </main>
  );
}
